/* eslint-disable unused-imports/no-unused-vars-ts */
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { tap } from "rxjs/operators";
import { appConfig, clientConfig } from "../../constant/app.constant";
import { SpinnerService } from "../spinner.service";

@Injectable({ providedIn: "root" })
export class ReturnOrderService {
  private _url = `${appConfig.BASE_URL}returnorders`;

  returnOrderLable: any = {
    show: false,
  };
  noOfRetries: number = 1;
  noOfGoBacksAfterReturnFailure: number = 1;
  parcelCount: number = 0;
  selectedParcelCount: number = 1;

  /* Summary: In case of Tendam, when carrier cancels first/original return,
     Centiro sends an email to the customer with a dynamic link to the portal where the customer can create a new return
     the original order remains active in Centiro UNTIL a new order has been placed with the same reference.
     In that case if the original order is already CANCELLED IN SECOND ITERATION we don't need to cancel it again,
     when the user gets error and goes back in the portal to update something so that he can create a successful return */
  originalReturnCancelled: boolean = false;

  constructor(private httpClient: HttpClient, private spinnerService: SpinnerService) {}

  resetFlags() {
    this.noOfRetries = 1;
    this.noOfGoBacksAfterReturnFailure = 1;
    this.originalReturnCancelled = false;
  }

  createReturnOrder(order: any) {
    const requestOptions = {
      params: new HttpParams(),
    };

    requestOptions.params.set("Content-Type", "application/json; charset=utf-8");

    this.spinnerService.show();

    return this.httpClient.post(`${this._url}/create`, order).pipe(
      tap(
        (response) => this.spinnerService.hide(),
        (error: any) => this.spinnerService.hide()
      )
    );
  }

  searchShipment(email, orderNo) {
    const request = {
      MerchantId: clientConfig.MERCHANT_ID,
      ReturnCenterId: clientConfig.RETURN_CENTER_ID,
      errorUri: clientConfig.ERROR_URI,
      postBackURL: clientConfig.POSTBACK_URL,
      postBackToken: clientConfig.POSTBACK_TOKEN,
      RedirectUrl: clientConfig.REDIRECT_URL,
      OrderNo: orderNo,
      ReceiverEmail: email,
    };

    return this.httpClient.post(`${this._url}/SearchShipment`, request);
  }

  getShipment() {
    const request = {
      MerchantId: clientConfig.MERCHANT_ID,
      ExternalIdentifier: clientConfig.EXTERNAL_ID,
      IdType: clientConfig.ID_TYPE,
      ReturnCenterId: clientConfig.RETURN_CENTER_ID,
      postBackURL: clientConfig.POSTBACK_URL,
      postBackToken: clientConfig.POSTBACK_TOKEN,
      RedirectUrl: clientConfig.REDIRECT_URL,
    };

    return this.httpClient.post(`${this._url}/GetShipment`, request);
  }

  cancelOrder(merchantId: string, externalId: string, shipmentType: string) {
    const request = {
      MerchantId:  merchantId,
      ExternalShipmentIdentifier: externalId,
      ShipmentType: shipmentType,
    };

    return this.httpClient.post(`${this._url}/CancelOrder`, request);
  }
}
